import { render } from "./BookingOptionalTourForm.vue?vue&type=template&id=657ca521&scoped=true"
import script from "./BookingOptionalTourForm.vue?vue&type=script&lang=js"
export * from "./BookingOptionalTourForm.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-657ca521"

export default script